import { render, staticRenderFns } from "./LexonScheduleComponent.vue?vue&type=template&id=2fbbd9f8&scoped=true&lang=pug"
import script from "./LexonScheduleComponent.vue?vue&type=script&lang=ts"
export * from "./LexonScheduleComponent.vue?vue&type=script&lang=ts"
import style0 from "./LexonScheduleComponent.vue?vue&type=style&index=0&id=2fbbd9f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbbd9f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fbbd9f8')) {
      api.createRecord('2fbbd9f8', component.options)
    } else {
      api.reload('2fbbd9f8', component.options)
    }
    module.hot.accept("./LexonScheduleComponent.vue?vue&type=template&id=2fbbd9f8&scoped=true&lang=pug", function () {
      api.rerender('2fbbd9f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonSchedule/LexonScheduleComponent.vue"
export default component.exports